const Languages = Object.freeze({
  BOKMAAL: Object.freeze({ id: "nb", text: "Norsk bokmål" }),
  NYNORSK: Object.freeze({ id: "nn", text: "Norsk nynorsk" }),
  ENGLISH: Object.freeze({ id: "en", text: "English" }),
})

const languageIds = Object.values(Languages).map(l => l.id)

module.exports = {
  Languages,
  languageIds,
}
